import { render, staticRenderFns } from "./ConfigureClues.vue?vue&type=template&id=13f7c194&scoped=true"
import script from "./ConfigureClues.vue?vue&type=script&lang=js"
export * from "./ConfigureClues.vue?vue&type=script&lang=js"
import style0 from "./ConfigureClues.vue?vue&type=style&index=0&id=13f7c194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7c194",
  null
  
)

export default component.exports